<div *ngIf="connect" class="loading-overlay">
    <img src="https://cdn.haitrieu.com/wp-content/uploads/2022/02/Icon-MB-Bank-MBB.png" alt="" width="50"
        class="spin" />
    <p class="mt-3 text-white">Đang truy cập miniapp...</p>
</div>

<div>
    <nav class="navbar navbar-expand-lg navbar-light py-3 position-sticky top-0 z-3" style="background-color: #141ed2">
        <div class="container">
            <div>
                <a class="navbar-brand text-black-50" href="/#/account/login">
                    <img loading="lazy" src="assets/images/Logo_LoathanhtoanMB1.png" alt="Logo" height="40" />
                </a>
            </div>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarNav">
                <ul class="navbar-nav ml-auto">
                    <li class="nav-item mt-2">
                        <button class="btn bg-white text-primary btn-lg rounded-4" style="margin-top: -0.3rem">
                            <a href="tel:1900998893" class="font-weight-bolder text-primary">
                                1900 99.88.93
                            </a>
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    </nav>

    <div class="container text-center">
        <img class="img-fluid w-75" src="../../../../assets/images/logo_500_300.png" />
    </div>
    <div class="service-wrapper">
        <div class="service-card">
            <div class="content text-center">Hóa đơn điện tử Viettel</div>
            <div>
                <div class="title text-center">
                    Tài khoản hóa đơn điện tử và chữ ký số của Quý khách đã được khởi tạo
                    thành công. Vui lòng truy cập miniapp Loa thanh toán trên ứng dụng
                    MBBank để bắt đầu sử dụng dịch vụ.
                </div>
                <div>
                    <button class="btn" (click)="onRenew()">Truy cập miniapp ngay</button>
                </div>
            </div>
        </div>
    </div>
</div>